import { connect } from 'react-redux';
import _ from 'lodash';

import Recovery from '../components/Recovery';
import { restoreObject } from '../../../store/modules/totaldata';

const mapActionCreators = {
  restoreObject,
};

const mapStateToProps = state => ({
  activities: _.filter(
    state.activity.activities,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
  companies: _.filter(
    state.company.companies,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
  projects: _.filter(
    state.project.projects,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
  tasks: _.filter(
    state.task.tasks,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
  staffs: _.filter(
    state.staff.staffs,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
  persons: _.filter(
    state.person.persons,
    o => typeof o !== 'undefined' && o.deleted_at !== null,
  ),
});

export default connect(mapStateToProps, mapActionCreators)(Recovery);



// WEBPACK FOOTER //
// ./src/routes/Recovery/containers/RecoveryContainer.js